import { motion } from "framer-motion";
import { ArrowRight, MoveRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import beforeImage from "@assets/stock_images/cluttered_messy_reta_4a18dc5d.jpg";
import afterImage from "@assets/stock_images/modern_clean_retail__5bfc255c.jpg";

const comparisonData = [
  {
    before: "Cierres de caja manuales y lentos",
    after: "Cierre automático en un solo clic",
  },
  {
    before: "Stock 'ciego' y productos perdidos",
    after: "Control total de inventario en tiempo real",
  },
  {
    before: "Ventas sin registro ni comprobantes",
    after: "Reportes detallados y recibos digitales",
  },
];

export default function Solutions() {
  return (
    <section
      id="soluciones"
      className="py-16 sm:py-20 lg:py-24 xl:py-32 bg-slate-900 text-white overflow-hidden"
    >
      <div className="container px-4 mx-auto relative">
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16 lg:mb-20 xl:mb-24 relative z-10">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-primary font-black tracking-[0.2em] uppercase text-xs mb-4 block"
          >
            La Transformación Digital
          </motion.span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold font-display tracking-tight mb-4 sm:mb-6">
            Tu negocio antes y después <br />{" "}
            <span className="text-primary">de QvaPOS</span>
          </h2>
          <p className="text-slate-400 text-base sm:text-lg font-light px-4">
            No solo vendemos software, vendemos la tranquilidad de saber que tu
            capital está seguro.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-16 sm:mb-20 lg:mb-24">
          {/* Before Column */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6 sm:space-y-8 order-2 lg:order-1"
          >
            <div className="relative group">
              <div className="absolute inset-0 bg-red-500/20 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl sm:rounded-[2rem]" />
              <div className="relative rounded-2xl sm:rounded-[2rem] overflow-hidden border-4 border-red-500/20 grayscale group-hover:grayscale-0 transition-all duration-700">
                <img
                  src={beforeImage}
                  alt="Negocio sin QvaPOS"
                  className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
                />
                <div className="absolute top-4 sm:top-6 left-4 sm:left-6 bg-red-500 text-white px-3 sm:px-4 py-1 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-widest shadow-lg">
                  Sin QvaPOS
                </div>
              </div>
            </div>
            <div className="space-y-3 sm:space-y-4">
              {comparisonData.map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 sm:gap-4 text-slate-400"
                >
                  <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-red-500/50 flex-shrink-0" />
                  <p className="text-sm sm:text-base font-medium">
                    {item.before}
                  </p>
                </div>
              ))}
            </div>
          </motion.div>

          {/* After Column */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6 sm:space-y-8 order-1 lg:order-2"
          >
            <div className="relative group">
              <div className="absolute inset-0 bg-primary/20 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl sm:rounded-[2rem]" />
              <div className="relative rounded-2xl sm:rounded-[2rem] overflow-hidden border-4 border-primary/40 shadow-[0_0_50px_-12px_rgba(59,130,246,0.5)]">
                <img
                  src={afterImage}
                  alt="Negocio con QvaPOS"
                  className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover"
                />
                <div className="absolute top-4 sm:top-6 right-4 sm:right-6 bg-primary text-white px-3 sm:px-4 py-1 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-widest shadow-lg">
                  Con QvaPOS
                </div>
              </div>
            </div>
            <div className="space-y-3 sm:space-y-4">
              {comparisonData.map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 sm:gap-4 text-white"
                >
                  <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-primary shadow-[0_0_10px_rgba(59,130,246,1)] flex-shrink-0" />
                  <p className="text-sm sm:text-base font-bold">{item.after}</p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>

        <div className="text-center">
          <Button
            onClick={() =>
              (window.location.href = "http://127.0.0.1:5000/register")
            }
            className="rounded-full px-6 sm:px-8 md:px-10 lg:px-12 h-12 sm:h-14 md:h-16 lg:h-20 text-sm sm:text-base md:text-lg lg:text-xl font-black bg-primary hover:bg-primary/90 shadow-2xl shadow-primary/40 group"
          >
            TRANSFORMAR MI NEGOCIO AHORA
            <ArrowRight className="ml-2 sm:ml-3 w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
}
